var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon",on:{"click":_vm.click}},[_c('i',{staticClass:"fas",class:( _obj = {}, _obj[_vm.name] = true, _obj['fa-fw'] =  _vm.fw, _obj )})])}
var staticRenderFns = []

export { render, staticRenderFns }